import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import About from './pages/about-page';
import Root from './routers/root';
import ErrorPage from './pages/error-page';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material';
import Home from './pages/HomePage/home';
import { SnackbarProvider } from 'notistack';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Root></Root>,
    errorElement: <ErrorPage></ErrorPage>,
    children: [
      { index: true, element: <Home></Home> },
      { path: "about", element: <About></About> }
    ]
  },
])

let theme = createTheme({
  typography: {
    body1: {
      fontFamily: 'Blinker',
    },
    button: {
      fontFamily: 'Blinker',
    },
    h1: {
      fontFamily: 'Blinker',
      fontWeight: 'bold'
    },
    h2: {
      fontFamily: 'Blinker',
      fontWeight: 'bold'
    },
    h3: {
      fontFamily: 'Blinker',
      fontWeight: 'bold'
    },
    h4: {
      fontFamily: 'Blinker',
      fontWeight: 'bold'
    },
    h5: {
      fontFamily: 'Blinker',
      fontWeight: 'bold'
    },
    h6: {
      fontFamily: 'Blinker',
      fontWeight: 'bold'
    },
  },
  palette: {
    body: {
      main: "#EEF4FC"
    },
    primary: {
      main: "#003da5"
    },
    white: {
      main: "#ffffff"
    },
    text: {
      primary: "#000000",
      secondary: "#4D5865"
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Poppins'
        },
      },
      defaultProps: {
        disableElevation: true,
      }
    },
  }
})

theme = responsiveFontSizes(theme);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SnackbarProvider  maxSnack={3}>
      <ThemeProvider theme={theme}>
        <RouterProvider router={router} />
      </ThemeProvider>
    </SnackbarProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
